import { makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: theme.palette.text.primary,
  },
}));

const LogoIcon = () => {
  const backstageTheme = useTheme();
  const classes = useStyles(backstageTheme);

  return (
    <svg 
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500">
      <g id="c">
        <g>
          <path className={classes.path} d="M211.268,352.453h-48.433l-31.1-39.49-31.099,39.49H52.389l56.231-67.25-58.621-70.384h48.221l33.546,42.429,34.232-42.429h48.196l-58.629,70.396,55.702,67.238Z" />
          <path className={classes.path} d="M447.073,285.363h-48.436l-31.099-39.49-31.095,39.49h-48.246l56.222-67.259-58.615-70.388h48.22l33.546,42.445,34.234-42.445h48.196l-58.632,70.399,55.705,67.248Z" />
          <polygon className={classes.path} points="239.549 147.547 260.373 147.547 260.373 352.341 239.549 352.341 239.549 147.547 239.549 147.547" />
        </g>
      </g>
    </svg>
  );
};

export default LogoIcon;
